module.exports = __webpack_public_path__ + "img/text-mark2.2d4c79df.png";